<template>
  <vs-card>
    <div slot="header">
      <h3>Veículos na base</h3>
    </div>
    <div
      class="flex flex-wrap justify-center items-center bg-white rounded-lg shadow gap-8 p-4"
    >
      <div
        class="square flex flex-col items-center"
        v-for="item in listVeiculos"
        :key="item.status"
      >
        <div :class="`chip-container bg-${getStatusColor(item.status)}`">
          {{ truncatedStatus(item.status) }}
        </div>
        <div
          class="quantity-container flex flex-col items-center justify-center"
        >
          <span
            class="quantity-text font-semibold text-gray-900 tracking-tight"
          >
            {{ item.quantidade_total }}
          </span>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
export default {
  props: ['listVeiculos'],
  data() {
    return {
      statusMap: {
        ATIVO: 'success',
        PENDENTE: 'warning',
        SUSPENSO: 'danger',
        INATIVO: 'danger',
        'SPC - INADIMPLENTE': 'danger',
        'INATIVAÇÃO PENDENTE (ASSINATURA TERMO DE CANCELAME': 'danger',
        CANCELADO: 'danger',
        INADIMPLENTE: 'danger',
        'INATIVAÇÃO PENDENTE (POR BOLETO)': 'danger',
      },
    };
  },
  methods: {
    getStatusColor(status) {
      return this.statusMap[status] || 'gray-500';
    },
    truncatedStatus(status) {
      const MAX_LENGTH = 20;
      return status.length > MAX_LENGTH
        ? status.substring(0, MAX_LENGTH) + '...'
        : status;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

.square {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.chip-container {
  border: 1px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 3rem;
  text-align: center;
  color: white;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
}

.quantity-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
}

.quantity-text {
  font-size: 1.5rem;
  height: auto;
  width: auto;
}

.text-gray-700 {
  color: #6d6d6d;
}
.text-gray-900 {
  color: #434343;
}
.text-lg {
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.15px;
}
</style>
